import { render, staticRenderFns } from "./CompanionVehicleSearch.vue?vue&type=template&id=5505a65b&"
import script from "./CompanionVehicleSearch.vue?vue&type=script&lang=js&"
export * from "./CompanionVehicleSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports